var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistericonpink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 17.3327V14.8327H9.66667V13.166H12.1667V10.666H13.8333V13.166H16.3333V14.8327H13.8333V17.3327H12.1667ZM2.16667 15.666C1.70833 15.666 1.31597 15.5028 0.989583 15.1764C0.663194 14.85 0.5 14.4577 0.5 13.9993V3.99935C0.5 3.54102 0.663194 3.14865 0.989583 2.82227C1.31597 2.49588 1.70833 2.33268 2.16667 2.33268H3V0.666016H4.66667V2.33268H9.66667V0.666016H11.3333V2.33268H12.1667C12.625 2.33268 13.0174 2.49588 13.3438 2.82227C13.6701 3.14865 13.8333 3.54102 13.8333 3.99935V9.08268C13.5556 9.04101 13.2778 9.02018 13 9.02018C12.7222 9.02018 12.4444 9.04101 12.1667 9.08268V7.33268H2.16667V13.9993H8C8 14.2771 8.02083 14.5549 8.0625 14.8327C8.10417 15.1105 8.18056 15.3882 8.29167 15.666H2.16667ZM2.16667 5.66602H12.1667V3.99935H2.16667V5.66602Z",
    fill: "#DB545D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistericonpink);
export default __webpack_public_path__ + "static/media/registericonpink.d69655abc994d1927725f38319beaeec.svg";
export { ForwardRef as ReactComponent };